module.exports = __webpack_public_path__ + "img/matrix-product.f1f89f97.svg";